import { Component, OnInit, Input } from '@angular/core';
import { IDocumentResponse } from '@literax/models/document.model';
import { IDocument } from '@literax/models/http/document/document.model';
import { ICommonParticipant } from '@literax/models/participant.model';
import { IFolder, IFolderV3 } from '@literax/models/promissory-notes.model';
import { ISignRequest } from '@literax/modules/documents/store/document/document.state';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
@UntilDestroy()
@Component({
  selector: 'literax-document-detail-information',
  templateUrl: './document-detail-information.component.html',
  styleUrls: ['./document-detail-information.component.scss']
})
export class DocumentDetailInformationComponent implements OnInit {
  @Input() document: IDocumentResponse;
  @Input() promissoryNoteCicle: IFolderV3;
  @Input() detailPromissory = false;
  beneficiaryName: string;
  balanceAmount: number;
  subscriberName: string;
  guaranteeName: string;
  contentVisible = true;
  attachmentNames: string;
  attachmentCount: number;
  arrayGuarantor: ICommonParticipant[];
  isDateVisible = false;
  delivery_date: Date;

  ngOnInit(): void {
    if (this.document && this.document.attachments) {
      this.attachmentNames = this.document.attachments
        .filter((a) => !a.primary)
        .map((a) => a.name + '.' + a.kind)
        .join(', ');
      this.attachmentCount = this.document.attachments.filter(
        (a) => !a.primary
      ).length;

      // this.isDateVisible =
      //   this.document.attachments[this.attachmentCount]?.delivery_date === null;
      // if (!this.isDateVisible) {
      //   this.delivery_date =
      //     this.document.attachments[this.attachmentCount]?.delivery_date;
      // }
    }
    if (this.detailPromissory && this.document) {
      this.searchParticipants();
    }
  }

  toggleTabContent() {
    this.contentVisible = !this.contentVisible;
  }

  searchParticipants() {
    this.arrayGuarantor = [];
    if (this.promissoryNoteCicle) {
      this.beneficiaryName = this.promissoryNoteCicle?.holder?.client?.name;
      this.balanceAmount = this.promissoryNoteCicle?.balanceAmount;
      this.subscriberName = this.promissoryNoteCicle?.subscriptorName;
    }

    if (this.document && this.document.signRequests) {
      this.document.signRequests.naturalPersons.forEach((signer) => {
        switch (signer.signatureRole.signatoryRoleName) {
          case 'subscriptor':
            this.subscriberName = signer.name;
            break;
          case 'guarantor':
            this.arrayGuarantor.push(signer);
            break;
        }
      });
    }
  }


}
